import React from "react";

function TablaNivelEducativa() {
  return (
    <div className="tablaGrafica tablaEducativa">
      <h5 className="tituloTabla">NIVEL EDUCATIVO</h5>
      <table>
        <thead>
          <tr>
            <th>Descripción</th>
            <th>Plaza</th>
            <th>Trabajadores</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Educación Primaria</td>
            <td>23425</td>
            <td>20924</td>
          </tr>
          <tr>
            <td>Bachillerato</td>
            <td>9446</td>
            <td>5303</td>
          </tr>
          <tr>
            <td>Bachillerato/Telebachillerato</td>
            <td>8576</td>
            <td>7099</td>
          </tr>
          <tr>
            <td>Educación Básica Personal de Apoyo y Asistencia</td>
            <td>6340</td>
            <td>5978</td>
          </tr>
          <tr>
            <td>Educación Preescolar</td>
            <td>6047</td>
            <td>5474</td>
          </tr>
          <tr>
            <td>Educación Secundaria General y Técnica</td>
            <td>5874</td>
            <td>1302</td>
          </tr>
          <tr>
            <td>Educación Física</td>
            <td>3183</td>
            <td>1952</td>
          </tr>
          <tr>
            <td>Educación Telesecundaria</td>
            <td>2589</td>
            <td>2419</td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <td>
              <strong>Total</strong>
            </td>
            <td>
              <strong>69468</strong>
            </td>
            <td>
              <strong>53509</strong>
            </td>
          </tr>
        </tfoot>
      </table>
    </div>
  );
}

export default TablaNivelEducativa;
